var exports = {
  "kL": "xe533113f--28fe17--container",
  "UU": "xe533113f--28fe17--name",
  "lZ": "xe533113f--28fe17--phone",
  "N4": "xe533113f--28fe17--note",
};

module.exports = exports;
